export default "__VITE_ASSET__Q0$jIY4W__"